module.exports = __webpack_public_path__ + "img/home_news_4.db9c9b65.png";